import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import * as _ from 'lodash';

import { environment } from '../../../environments/environment';
import { AuthorizationService } from '../../services/authorization.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureGuard implements CanActivate {
  constructor(
    private router: Router,
    private authorizationService: AuthorizationService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const featureName: string = route.data.feature;

    await this.authorizationService.ready;

    return this.evaluate(featureName);
  }

  private evaluate(featureName: string): boolean | UrlTree {
    const { hasFeature, hasAppAccess } = this.checkFeatureAccess(featureName);
    if (!hasAppAccess) {
      return this.router.parseUrl('no-access');
    }

    if (hasAppAccess && hasFeature) {
      return true;
    }

    return this.router.parseUrl('');
  }

  private checkFeatureAccess(featureName: string) {
    const features =
      this.authorizationService.HealthcareTopBar?.currentUserDetails?.Features;
    const appName = environment.applicationNameBi;
    const appAccessFeature = environment.applicationAccessFeature;
    const hasFeature = features.some(
      (f) => f.App === appName && f.Name === featureName
    );
    const hasAppAccess = features.some(
      (f) => f.App === appName && f.Name === appAccessFeature
    );
    return { hasFeature, hasAppAccess };
  }
}
